import { Col, Container, Row } from "react-bootstrap";

import twitterLogo from "../assets/images/twitterlogo.png";
import { onClickUrl } from "../utils/helpers";
import PageHeader from "./bars/PageHeader";

export const Contact = () => {
  return (
    <>
      <PageHeader header={"Contact Us"} />
      <Container className="main-container">
        <Row className="justify-content-center">
          <Col sm={8} md={6} xl={4} xxl={3}>
            <div className="container-wrapper">
              <Container className="mt-3">
                <Row>
                  <Col>
                    <h2>Contact Us</h2>
                    <hr className="header-line" />
                    <h3 className="banner">Feedback</h3>
                    You can provide direct feedback using Google form
                    <p />
                    <Row className="justify-content-center">
                      <Col className="col-2">
                        <img
                          src="https://kstatic.googleusercontent.com/files/9f04faac24aed8bf8fb381029de951128d1d36373f89675265a6654d0c47b74b2d83a26b68b834ce2eea3bfe8001966f76895888138f135a81d099fc207c73bb"
                          alt="Google form"
                          id="contact-form"
                          onClick={onClickUrl(
                            "https://docs.google.com/forms/d/e/1FAIpQLSe_j3dUfOKXfrh4k3zjc2favOJM28HtPACoBNmxCHqBT1FwZg/viewform?usp=sf_link"
                          )}
                        />
                      </Col>
                    </Row>
                    <p />
                    <h3 className="banner">Social Media</h3>
                    Keep up with latest info
                    <p />
                    <Row className="justify-content-center">
                      <Col className="col-2 text-align-center">
                        <img
                          id="twitter-logo"
                          src={twitterLogo}
                          width="25px"
                          onClick={onClickUrl("https://twitter.com/purrser")}
                          alt="Purrser profile"
                        />
                      </Col>
                      <Row
                        className="justify-content-center"
                        style={{ textAlign: "center" }}
                      >
                        <Col className="col-12">@purrser</Col>
                      </Row>
                    </Row>
                    <p />
                    <h3 className="banner">Email</h3>
                    For all other inquiries:
                    <p />
                    <Row className="justify-content-center">
                      <Col className="col-2 text-align-center">
                        <a href="mailto:contact@purrser.com">
                          <i className="fa-solid fa-envelope fa-2x"></i>
                        </a>
                      </Col>
                      <Row
                        className="justify-content-center"
                        style={{ textAlign: "center" }}
                      >
                        <Col className="col-12">contact@purrser.com</Col>
                      </Row>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Contact;
